import { initialState } from './initial';
import { reducers } from './reducers';

export const stateSegment = {
  initialState,
  reducers,
};
